import SDKConfigurationModel from "../../Configurator/Models/SDKConfiguraitonModel";
import StandingGameFacade from "./Facade/StandingGameFacade";
import StandingGameRankingsFilters from "./Models/Filters/StandingGameRankingsFilters";
import StandingGamesFilters from "./Models/Filters/StandingGamesFilters";

export default class StandingGame {
  private facade: StandingGameFacade = null;

  constructor(config: SDKConfigurationModel) {
    this.facade = new StandingGameFacade(config);
  }

  public getGames = async (
    filters?: StandingGamesFilters | null,
    disableCache?: boolean
  ) => {
    return await this.facade.getGames(filters, disableCache);
  };

  public getGameById = async (gameId: string, disableCache?: boolean) => {
    return await this.facade.getGameById(gameId, disableCache);
  };

  public makePrediction = async (gameId: string, prediction: string[]) => {
    return await this.facade.makePrediction(gameId, prediction);
  };

  public updatePrediction = async (
    gameId: string,
    predictionId: string,
    prediction: string[]
  ) => {
    return await this.facade.updatePrediction(gameId, predictionId, prediction);
  };

  public getGamePredictionForUser = async (
    gameId: string,
    profileId: string,
    disableCache?: boolean
  ) => {
    return await this.facade.getGamePredictionForUser(
      gameId,
      profileId,
      disableCache
    );
  };

  public getRankings = async (
    gameId: string,
    filters?: StandingGameRankingsFilters,
    disableCache?: boolean
  ) => {
    return await this.facade.getRankings(gameId, filters, disableCache);
  };
}
